export default {
  category: {
    title: 'Gestión de Categorías de Artículos',
    addNew: 'Agregar Categoría',
    createTitle: 'Crear Categoría',
    editTitle: 'Editar Categoría',
    form: {
      category: 'Categoría',
      categoryPlaceholder: 'Ingrese el nombre de la categoría',
      categoryRequired: 'Por favor ingrese el nombre de la categoría',
      language: 'Idioma',
      languagePlaceholder: 'Seleccione idioma',
      languageRequired: 'Por favor seleccione el idioma',
      isActive: 'Activo',
      isActivePlaceholder: 'Seleccione estado',
      name: 'Nombre de Categoría',
      namePlaceholder: 'Ingrese el nombre de la categoría',
      nameRequired: 'Por favor ingrese el nombre de la categoría',
      slug: 'Slug',
      slugPlaceholder: 'Por favor ingrese slug',
      description: 'Descripción',
      descriptionPlaceholder: 'Ingrese la descripción de la categoría',
      sortOrder: 'Orden de Clasificación',
      sortOrderPlaceholder: 'Los números menores aparecen primero',
      seoTitle: 'Título SEO',
      seoTitlePlaceholder: 'Ingrese título SEO',
      seoDescription: 'Descripción SEO',
      seoDescriptionPlaceholder: 'Ingrese descripción SEO',
      seoKeywords: 'Palabras Clave SEO',
      seoKeywordsPlaceholder: 'Separe múltiples palabras clave con comas',
      canonicalUrl: 'URL Canónica',
      canonicalUrlPlaceholder: 'Ingrese URL canónica',
      ogTitle: 'Título OG',
      ogTitlePlaceholder: 'Ingrese título OG',
      ogDescription: 'Descripción OG',
      ogDescriptionPlaceholder: 'Ingrese descripción OG',
      ogImage: 'Imagen OG',
      ogImagePlaceholder: 'Ingrese URL de imagen OG',
    },
    table: {
      name: 'Nombre de Categoría',
      slug: 'Slug',
      description: 'Descripción',
      language: 'Idioma',
      isActive: 'Estado',
      sortOrder: 'Orden de Clasificación',
      updateTime: 'Actualizado en',
      action: 'Acción',
    },
    tabs: {
      basic: 'Información Básica',
      seo: 'Configuración SEO',
      og: 'Configuración OG',
    },
  },
  tag: {
    title: 'Gestión de Etiquetas de Artículos',
    addNew: 'Agregar Etiqueta',
    createTitle: 'Crear Etiqueta',
    editTitle: 'Editar Etiqueta',
    form: {
      tag: 'Etiqueta',
      tagPlaceholder: 'Ingrese el nombre de la etiqueta',
      language: 'Idioma',
      languagePlaceholder: 'Seleccione idioma',
      languageRequired: 'Por favor seleccione el idioma',
      isActive: 'Activo',
      isActivePlaceholder: 'Seleccione estado',
      name: 'Nombre de Etiqueta',
      namePlaceholder: 'Ingrese el nombre de la etiqueta',
      nameRequired: 'Por favor ingrese el nombre de la etiqueta',
      slug: 'Slug',
      slugPlaceholder: 'Por favor ingrese slug',
      description: 'Descripción',
      descriptionPlaceholder: 'Ingrese la descripción de la etiqueta',
      seoTitle: 'Título SEO',
      seoTitlePlaceholder: 'Ingrese título SEO',
      seoDescription: 'Descripción SEO',
      seoDescriptionPlaceholder: 'Ingrese descripción SEO',
      seoKeywords: 'Palabras Clave SEO',
      seoKeywordsPlaceholder: 'Separe múltiples palabras clave con comas',
      canonicalUrl: 'URL Canónica',
      canonicalUrlPlaceholder: 'Ingrese URL canónica',
      ogTitle: 'Título OG',
      ogTitlePlaceholder: 'Ingrese título OG',
      ogDescription: 'Descripción OG',
      ogDescriptionPlaceholder: 'Ingrese descripción OG',
      ogImage: 'Imagen OG',
      ogImagePlaceholder: 'Ingrese URL de imagen OG',
    },
    table: {
      "language": "Idioma",
      name: 'Nombre de Etiqueta',
      slug: 'Slug',
      description: 'Descripción',
      isActive: 'Estado',
      usageCount: 'Recuento de Uso',
      updateTime: 'Actualizado en',
      action: 'Acción',
    },
    tabs: {
      basic: 'Información Básica',
      seo: 'Configuración SEO',
      og: 'Configuración OG',
    },
  },
  article: {
    title: 'Gestión de Lista de Artículos',
    addNew: 'Agregar Artículo',
    createTitle: 'Crear Artículo',
    editTitle: 'Editar Artículo',
    form: {
      keyword: 'Título del artículo',
      keywordPlaceholder: 'Ingrese el título del artículo',
      category: 'Categoría',
      categoryPlaceholder: 'Seleccione categoría',
      categoryRequired: 'Por favor seleccione categoría',
      language: 'Idioma',
      languagePlaceholder: 'Seleccione idioma',
      languageRequired: 'Por favor seleccione el idioma',
      status: 'Estado',
      statusPlaceholder: 'Seleccione estado',
      dateRange: 'Fecha de Publicación',
      startDate: 'Fecha de Inicio',
      endDate: 'Fecha de Fin',
      title: 'Título del Artículo',
      titlePlaceholder: 'Ingrese el título del artículo',
      titleRequired: 'Por favor ingrese el título del artículo',
      slug: 'Slug',
      slugPlaceholder: 'Por favor ingrese slug',
      summary: 'Resumen',
      summaryPlaceholder: 'Ingrese el resumen del artículo',
      content: 'Contenido',
      coverImage: 'Imagen de Portada',
      coverImagePlaceholder: 'Ingrese URL de imagen de portada',
      publishedAt: 'Publicado en',
      tags: 'Etiquetas',
      tagsPlaceholder: 'Seleccione etiquetas',
      sortOrder: 'Orden de Clasificación',
      sortOrderPlaceholder: 'Los números menores aparecen primero',
      isTop: 'Fijar en la Parte Superior',
      seoEnabled: 'Habilitar SEO',
      seoTitle: 'Título SEO',
      seoTitlePlaceholder: 'Ingrese título SEO',
      seoDescription: 'Descripción SEO',
      seoDescriptionPlaceholder: 'Ingrese descripción SEO',
      seoKeywords: 'Palabras Clave SEO',
      seoKeywordsPlaceholder: 'Separe múltiples palabras clave con comas',
      canonicalUrl: 'URL Canónica',
      canonicalUrlPlaceholder: 'p. ej.: https://www.yoursite.com/article/Points/123',
      ogTitle: 'Título OG',
      ogTitlePlaceholder: 'Ingrese título OG',
      ogDescription: 'Descripción OG',
      ogDescriptionPlaceholder: 'Ingrese descripción OG',
      ogImage: 'Imagen OG',
      ogImagePlaceholder: 'Ingrese URL de imagen OG',
    },
    table: {
      id: 'ID',
      article: 'Artículo',
      coreSeo: 'SEO Central',
      coverImage: 'Imagen de Portada',
      socialOg: 'Social OG',
      isTop: 'Fijar',
      status: 'Estado',
      viewCount: 'Estadísticas de Acceso de Artículos (PV/UV)',
      action: 'Acción',
      title: 'Título',
      category: 'Categoría',
      tags: 'Etiquetas',
      language: 'Idioma',
      publisher: 'Publicador',
      updateTime: 'Hora de Actualización',
      canonicalUrl: 'URL Canónica',
      seoKeywords: 'Palabras Clave',
      dynamicParams: 'Parámetros Dinámicos',
      noImage: 'Sin Imagen',
      noOgImage: 'Sin Imagen OG',
      publishedAt: 'Publicado en',
    },
    status: {
      pending: 'Pendiente',
      published: 'Publicado',
      rejected: 'Rechazado',
    },
      actions: {
        preview: 'Vista Previa',
        edit: 'Editar',
        seoEdit: 'Edición SEO',
        delete: 'Eliminar',
        approve: 'Aprobar',
        reject: 'Rechazar',
        confirmApprove: '¿Está seguro de que desea aprobar este artículo?',
        confirmReject: '¿Está seguro de que desea rechazar este artículo?',
      },
      seoEdit: 'Edición SEO y OG',
      preview: {
        original: 'Contenido Original',
        processed: 'Contenido Reemplazado',
      },
    tabs: {
      basic: 'Información Básica',
      seo: 'Configuración SEO',
      og: 'Configuración OG',
    },
  },
  internalLink: {
    title: 'Gestión de Palabras Clave de Enlaces Internos',
    add: 'Agregar Palabra Clave',
    edit: 'Editar Palabra Clave',
    keyword: 'Palabra Clave',
    keywordTag: 'Etiqueta de Palabra Clave',
    keywordPlaceholder: 'Por favor ingrese palabra clave',
    url: 'URL',
    urlPlaceholder: 'Por favor ingrese URL',
    isBrand: 'Término de Marca',
    maxReplacement: 'Reemplazo Máximo',
    maxReplacementPlaceholder: 'Ingrese recuento máximo de reemplazo (Por defecto: 5 para normal, 2 para marca)',
    isActive: 'Habilitado',
  },
};

